import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@common-ui/ui';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CreateNewReportForm from './CreateNewReportForm';
import { useHistory } from 'react-router-dom';
import routerPathEnum from '../../../../enums/routerPathEnum';

/**
 * This is the first step of the report modal
 * It allows a new report to be created
 *
 * @param {*} data - props passed down from the parent component, the current object state for the modal
 * @param {*} setData - function passed down from the parent component, to update the current object state for the modal
 *
 * @returns {JSX.Element} - The first step of the report modal
 */

export default function CreateNewReport({ open = 'CreateNewReport', setOpen, selectedImageIds }) {
  const history = useHistory();
  const page = history.location.pathname;

  const imageList = () => {
    if (page === routerPathEnum.IMAGE_EDITOR || page === routerPathEnum.IMAGES) {
      return selectedImageIds;
    } else {
      return [];
    }
  };

  const handleSetOpen = () => {
    if (!setOpen) {
      return;
    } else {
      setOpen('CreateNewReport');
    }
  };
  return (
    <Accordion sx={container} expanded={open === 'CreateNewReport'} onChange={handleSetOpen} square>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={text}>Create New Report</Typography>
      </AccordionSummary>
      <AccordionDetails sx={details}>
        <CreateNewReportForm imageList={imageList()} />
      </AccordionDetails>
    </Accordion>
  );
}

const details = {
  display: 'flex',
  justifyContent: 'center',
};

const container = {
  boxShadow: 'none',
};

const text = {
  fontSize: '18px',
  display: 'flex',
  alignItems: 'center',
};
